import Endpoints from "../../server-istances/Endpoints";


export default class SSOService {
  private static instance: SSOService;

  private accessToken: string | null = null;
  private refreshToken: string | null = null;

  private constructor() {}

  static getInstance() {
    if (!SSOService.instance) {
      SSOService.instance = new SSOService();
    }
    return SSOService.instance;
  }

  public doLogin() {
    const endpoint = Endpoints.getInstance();
    const keycloakConfig = endpoint.KEYCLOACK;

    if (!keycloakConfig) throw new Error("Keycloak config mancante");

    const { url, realm, clientId } = keycloakConfig;
    const redirectUri = window.location.origin + window.location.pathname;

    const codeChallenge = "";

    const loginUrl = `${url}realms/${realm}/protocol/openid-connect/auth?` +
                     `client_id=${clientId}` +
                     `&redirect_uri=${encodeURIComponent(redirectUri)}` +
                     `&response_type=code` +
                     `&scope=openid` +
                     (codeChallenge ? `&code_challenge=${codeChallenge}&code_challenge_method=S256` : "");

    window.location.href = loginUrl;
  }

  public doLogout() {
    this.accessToken = null;
    this.refreshToken = null;

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    localStorage.removeItem("redirectAfterLogin");

    const endpoint = Endpoints.getInstance();
    const keycloakConfig = endpoint.KEYCLOACK;

    if (keycloakConfig) {
      const { url, realm } = keycloakConfig;
      const logoutUrl = `${url}realms/${realm}/protocol/openid-connect/logout`;
      window.location.href = logoutUrl;
    }
  }
	
  public getCodeFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("code");
  }

  public getAccessToken(): string | null {
    if (!this.accessToken) {
      this.accessToken = localStorage.getItem("accessToken");
    }
    return this.accessToken;
  }

  public setAccessToken(token: string) {
    this.accessToken = token;
    localStorage.setItem("accessToken", token);
  }

  public getRefreshToken(): string | null {
    if (!this.refreshToken) {
      this.refreshToken = localStorage.getItem("refreshToken");
    }
    return this.refreshToken;
  }

  public setRefreshToken(token: string) {
    this.refreshToken = token;
    localStorage.setItem("refreshToken", token);
  }

  public isAccessTokenExpired(): boolean {
    const token = this.getAccessToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const now = Math.floor(Date.now() / 1000);
      return payload.exp && payload.exp < now;
    } catch {
      return true;
    }
  }
}
	
